<template>
  <v-app>
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <v-container fluid>
            <v-card elevation="2" outlined>
              <v-card-title>
                <!--                                    v-if="$can('transaction_create')"-->
                <v-btn to="/tariff/create" class="btn-add-with-text">
                  <v-icon>mdi-plus</v-icon>
                  افزودن
                </v-btn>
                <v-spacer />
                {{ $t($route.meta.title) }}
                <v-spacer />
                <!--                <v-btn :loading="loading" @click="reloadTable"-->
                <!--                       class="btn-update">-->
                <!--                  <v-icon>mdi-refresh</v-icon>-->
                <!--                  به روزرسانی-->
                <!--                </v-btn>-->
              </v-card-title>
              <v-divider />

              <div class="row">
                <div class="col-md-12 p-5">
                  <data-table
                    :data="data"
                    orderDir="desc"
                    :columns="columns"
                    :debounce-delay="5000"
                    :translate="translate"
                    :per-page="[10, 25, 50, 100, 200, 400]"
                    @on-table-props-changed="reloadTable"
                  >
                  </data-table>
                </div>
              </div>
            </v-card>
          </v-container>
        </div>
      </div>
    </div>
  </v-app>
</template>

<script>
import { SET_BREADCRUMB } from "../../../../core/services/store/breadcrumbs.module";
import Btn from "../../categories/Btn";

export default {
  components: {
    Btn,
  },
  data() {
    return {
      loading: false,
      translate: {
        nextButton: "بعدی",
        previousButton: "قبلی",
        rowsPerPageText: "تعداد در صفحه",
        noDataText: "داده ای برای نمایش وجود ندارد",
        placeholderSearch: "جستجو",
      },
      tableProps: {
        search: "",
        length: 10,
        column: "id",
        dir: "desc",
      },
      url: "tariff",
      data: {},
      columns: [
        {
          label: "شناسه",
          name: "id",
          width: "50px",
          orderable: true,
        },
        {
          label: "عنوان",
          name: "title",
          orderable: true,
          serchable: true,
        },
        {
          label: "قیمت",
          name: "price",
          orderable: true,
        },
        {
          label: "تعداد",
          name: "count",
          orderable: true,
        },
        {
          label: "اعتبار (روز)",
          name: "expire_day",
          orderable: true,
        },
        {
          label: "قابلت دایورت",
          name: "can_divert",
          orderable: true,
          transform: (value) => {
            return value.data.can_divert ? "دارد" : "ندارد";
          },
        },

        {
          label: "رند",
          name: "is_fluent",
          orderable: true,
          transform: (value) => {
            return value.data.is_fluent ? "هست " : "نیست";
          },
        },

        {
          label: "وضعیت",
          name: "show",
          transform: (value) => {
            return value.data.show ? "فعال" : "غیر فعال";
          },
        },
        {
          label: "خط بازگشتی",
          name: "is_recursive",
          transform: (value) => {
            return value.data.is_recursive ? "بازگشتی" : "غیر بازگشتی";
          },
        },
        {
          label: "تاریخ ویرایش",
          name: "updated_at",
          orderable: true,
          transform: (val) => {
            return this.$options.filters.longDate(val.data.updated_at);
          },
        },

        {
          label: "عملیات",
          name: "action",
          component: Btn,
          event: "action",
          handler: this.action,
          meta: {
            permission_prefix: "pack_",
          },
        },
      ],
    };
  },
  methods: {
    reloadTable(tableProps) {
      this.getPacks(this.url, tableProps);
    },

    getPacks(url = this.url, query = this.tableProps) {
      this.loading = true;
      this.requestApiGet(url, query)
        .then((response) => {
          this.loading = false;
          this.data = response.data;
        })
        .catch((error) => {});
    },

    action(data, type) {
      this[type](data);
    },

    delete(data) {
      this.$swal({
        title: "حذف بسته",
        text: "آیا از حذف تعرفه اطمینان دارید؟",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بله",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.isConfirmed) {
          this.requestApiDelete(`${this.url}/${data.id}`)
            .then((response) => {
              this.reloadTable(this.url);
              this.$toast.success("تعرفه با موفقیت حذف شد");
            })
            .catch((error) => {});
        }
      });
    },

    edit(data) {
      this.$router.push({
        name: "tariff.edit",
        params: {
          id: data.id,
        },
      });
    },
  },

  created() {
    this.getPacks(this.url);
    this.$store.dispatch(SET_BREADCRUMB, [{ title: this.$route.meta.title }]);
  },
};
</script>
